// Additional Vendors Bundle
// Libraries that have npm packages and work well with webpack

// CSS Imports
import 'animate.css/animate.min.css';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import 'aos/dist/aos.css';
import 'glightbox/dist/css/glightbox.min.css';
import './local-vendors/slicknav.css';

// JavaScript Imports
import 'owl.carousel';
import AOS from 'aos';
import GLightbox from 'glightbox';

// SlickNav - Local file import (working version)
import './local-vendors/jquery.slicknav.min.js';

// Initialize AOS globally
if (typeof window !== 'undefined') {
    window.AOS = AOS;
    window.GLightbox = GLightbox;
    
    // Auto-initialize AOS when bundle loads
    document.addEventListener('DOMContentLoaded', function() {
        AOS.init({
            duration: 800,
            easing: 'ease-in-out',
            once: true,
            mirror: false
        });
        
        // Auto-initialize GLightbox for all lightbox elements
        const lightbox = GLightbox({
            selector: '.glightbox, .popup-video',
            touchNavigation: true,
            loop: true,
            autoplayVideos: false
        });
        
        console.log('  - GLightbox auto-initialized');
    });
}

// Console logs to verify loading
console.log('✅ Additional Vendors Bundle loaded');
console.log('  - animate.css loaded');
console.log('  - owl.carousel CSS loaded');
console.log('  - owl.carousel theme loaded'); 
console.log('  - owl.carousel JS loaded');
console.log('  - AOS CSS loaded');
console.log('  - AOS JS loaded and auto-initialized');
console.log('  - GLightbox CSS loaded');
console.log('  - GLightbox JS loaded');
console.log('  - SlickNav CSS loaded (local file)');
console.log('  - SlickNav JS loaded (local file)');

// Verify libraries are properly registered
if (typeof jQuery !== 'undefined') {
    if (jQuery.fn.owlCarousel) {
        console.log('  - owl.carousel jQuery plugin: ✅ REGISTERED');
    } else {
        console.error('  - owl.carousel jQuery plugin: ❌ NOT REGISTERED');
    }
    
    if (jQuery.fn.slicknav) {
        console.log('  - slicknav jQuery plugin: ✅ REGISTERED');
    } else {
        console.error('  - slicknav jQuery plugin: ❌ NOT REGISTERED');
    }
} else {
    console.error('  - jQuery not available for plugin verification');
}

// Verify modern libraries are available globally
if (typeof window !== 'undefined') {
    if (typeof AOS !== 'undefined') {
        console.log('  - AOS global: ✅ AVAILABLE');
    } else {
        console.error('  - AOS global: ❌ NOT AVAILABLE');
    }
    
    if (typeof GLightbox !== 'undefined') {
        console.log('  - GLightbox global: ✅ AVAILABLE');
    } else {
        console.error('  - GLightbox global: ❌ NOT AVAILABLE');
    }
}

// Note: This bundle contains animate.css, owl.carousel, AOS, GLightbox and SlickNav (local CSS+JS files)
